import { BookingStatus } from '@massilia/prisma-generated/enums';
import { z } from 'zod';
import { isoDateString } from '../_shared/dates.js';
import { withRenamedDeprecatedKey } from '../_shared/deprecated-key.js';
// `installmentPaymentDeadline` est l'ancien nom de `paymentDeadline` : alias déprécié,
// à supprimer à la release suivante.
export const updateBookingConditionsSchema = withRenamedDeprecatedKey(z.object({
    // `nullish` et non `optional` : le formulaire d'échéances envoie toujours les deux
    // dates, à `null` quand l'agent les efface ou qu'elles n'ont jamais été saisies.
    // `updateConditions` sait déjà effacer sur `null` — seule l'entrée le refusait, et
    // tout enregistrement d'un dossier sans date limite d'acompte partait en 400.
    // La clé absente reste absente : la distinction « non fourni » / « effacé », sur
    // laquelle repose le service, est intacte.
    depositDeadline: isoDateString().nullish(),
    exchangeAllowed: z.boolean().optional(),
    exchangeFeeDescription: z.string().optional(),
    installmentChosen: z.boolean().optional(),
    installmentMinimumDepositAmount: z.coerce.number().nullish(),
    paymentDeadline: isoDateString().nullish(),
    refundAllowed: z.boolean().optional(),
    refundFeeDescription: z.string().optional(),
}), 'installmentPaymentDeadline', 'paymentDeadline');
export const updateBookingStatusSchema = z.object({
    status: z.nativeEnum(BookingStatus),
});
/**
 * Code promo appliqué à un dossier DÉJÀ RÉSERVÉ, depuis le back-office. Distinct de
 * `applyPromoCodeSchema` (session de checkout) : ici le dossier existe, il peut déjà
 * être payé, et l'écart doit être régularisé.
 */
export const applyBookingPromoCodeSchema = z.object({
    code: z.string().min(1),
    // Absent ou `true` : si le dossier ressort surpayé, l'avoir correspondant est créé
    // dans la foulée. `false` laisse l'agent régulariser à la main depuis l'onglet
    // Paiements — le geste reste le sien, on ne fait que le proposer par défaut.
    createCreditNote: z.boolean().optional(),
});
export const updateBookingInsurancePriceSchema = z.object({
    price: z.number().min(0),
});
export const createBookingExtraSchema = z.object({
    bookingId: z.string().min(1),
    fileId: z.string().optional(),
    fileName: z.string().optional(),
    name: z.string().min(1),
    providerName: z.string().min(1),
    description: z.string().optional(),
    fileType: z.string().optional(),
    // Coût prestataire, requis à la création : sans lui la prestation entre dans
    // le dossier avec une marge inconnue, et rien ne rappellera plus de la
    // renseigner. Les prestations antérieures au suivi restent à NULL en base —
    // c'est le seul cas d'absence qu'on accepte.
    netAmountCents: z.number().min(0),
    price: z.number().min(0),
    providerExternalRef: z.string().min(1),
});
export const updateBookingExtraSchema = z.object({
    fileId: z.string().optional(),
    fileName: z.string().optional(),
    name: z.string().optional(),
    providerName: z.string().optional(),
    description: z.string().nullish(),
    fileType: z.string().optional(),
    // Optionnel comme tous les champs de ce PATCH partiel, mais jamais annulable :
    // pas de `nullish()`. Un net effacé rendrait une marge déjà mesurée à
    // l'inconnu, ce que le formulaire n'a aucune raison de demander.
    netAmountCents: z.number().min(0).optional(),
    price: z.number().min(0).optional(),
    providerExternalRef: z.string().optional(),
});
